import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls to the element matching location.hash whenever the hash changes
 * (including when arriving on "/" from another route via a "/#section" link).
 * If there is no hash, scrolls to the top.
 */
export function ScrollToHash() {
  const {
    hash,
    pathname
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Wait a frame so the target section is mounted before scrolling.
      const raf = requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
  }, [hash, pathname]);
  return null;
}